/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Manager_Remove_Member_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Remove {name}?" |
*
* @param {Team_Manager_Remove_Member_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_member_confirm_title = /** @type {((inputs: Team_Manager_Remove_Member_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Member_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.name} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} entfernen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovere ${i?.name}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить ${i?.name}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Quitar a ${i?.name}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移除 ${i?.name}？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を削除しますか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} को हटाएँ?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remover ${i?.name}?`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}?`)
});